
import React from "react";
import "./Portfolio.css";
import IMG1 from "../asserts/amazon-website^2019^homepage-august.jpg";
import IMG2 from "../asserts/eshop-website-isolated-gadget-devices-600w-1236643123.webp";
import IMG3 from "../asserts/10713004.jpg";
import IMG4 from "../asserts/iStock-1272546741-e1616381252729.jpg";
import IMG5 from "../asserts/portfolio5.jpg";
import IMG6 from "../asserts/portfolio6.jpg";

//it can be get with UseEffect hook
const data = [
  {
    id: 1,
    image: IMG1,
    title: "Amazone clone by using React js",
    github: "https://github.com/niraj2634",
    demo: "https://clone-70410.web.app/",
  },
  {
    id: 2,
    image: IMG2,
    title: "Shoppping-Site by using react js And Api",
    github: "https://github.com",
    demo: " https://shopping-app-7ed74.web.app",
  },
  {
    id: 3,
    image: IMG3,
    title: "Movies Site by using react js And Api",
    github: "https://github.com",
    demo: "https://movies-132e8.web.app/",
  },
  {
    id: 4,
    image: IMG4,
    title: "Covid-19-app by using react js And Api Fetch",
    github: "https://github.com",
    demo: "https://covid-apps-23fef.web.app/",
  },
  {
    id: 5,
    image: IMG5,
    title: "Charts templates & infographics in Figma",
    github: "https://github.com",
    demo: "#",
  },
  {
    id: 6,
    image: IMG6,
    title: "Charts templates & infographics in Figma",
    github: "https://github.com",
    demo: "#",
  },
];

const Portfolio = () => {
  return (
    <section id="portfolio">
      <h5>My Recent Work</h5>
      <h2>Project</h2>
      <div className="container portfolio-container">
        {data.map((person) => {
          const { id, image, title, github, demo }=person
          return (
            <article key={id} className="portfolio-item">
              <div className="portfolio-item-image">
                <img src={image} alt={title} />
              </div>
              <h3>{title}</h3>
              <div className="portfolio-item-cta">
                <a href={github} className="btn" target="_blank">
                  GitHub
                </a>
                <a href={demo} className="btn btn-primary" target="_blank">
                  Live Demo
                </a>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
};

export default Portfolio;